<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}"
          style="background-image: url('assets/images/{{bannerImage}}');">
          <h1 class="bani-title">
            {{ activeLanguageTranslations?.title | translate }}
          </h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">

        <!--Section 1-->
        <!--Section 2-->
        <div class="static-content-paragraph">
          <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
            <div class="static-content-heading-wrapper">{{activeLanguageTranslations?.title}}</div>
            <div class="static-content-paragraph">
              <!-- <b> {{ activeLanguageTranslations?.sggsProject }} </b> <br />
          {{ activeLanguageTranslations?.subTagLine }} -->
            </div>

            <!-- <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.theVision }}</div> -->
            <div class="static-content-paragraph">
              {{ activeLanguageTranslations?.paragraph1 | translate }}
            </div>

            <div class="static-content-paragraph">
              <div class="id smaller contact-form">

                <div class="w-form" *ngIf="formOne">


                  <div class="dropdown-box">
                    <select name="type" class="select-dropdown" (change)="changeColor($event)">
                      <option value="1"> General Comment & Questions</option>
                      <option value="2"> Feedback & Testimonals</option>
                    </select>
                  </div>

                  <form [formGroup]="contactForm" (ngSubmit)="onSubmit(1)">

                    <div class="form-hor">
                      <div class="input-div">
                        <input formControlName="firstName" type="text" name="first-name" placeholder="First Name">
                        <span class="c-error"
                          *ngIf="contactForm.controls.firstName?.errors?.['required'] && contactForm.controls.firstName?.touched">First
                          Name is required.</span>
                      </div>
                      <div class="form-hor-spacer"></div>
                      <div class="input-div">
                        <input formControlName="lastName" type="text" name="last-name" placeholder="Last Name">
                        <span class="c-error"
                          *ngIf="contactForm.controls.lastName?.errors?.['required'] && contactForm.controls.lastName?.touched">Last
                          Name is required.</span>
                      </div>
                    </div>

                    <div class="form-inp-aa">

                      <div class="input-div">
                        <input formControlName="emailID" id="email" type="email" placeholder="Email">
                        <span class="c-error" *ngIf="contactForm.controls.emailID?.errors?.['email']">Email must be a
                          valid email address.</span>
                        <span class="c-error"
                          *ngIf="contactForm.controls.emailID?.errors?.['required'] &&  contactForm.controls.emailID?.touched">Email
                          is required.</span>
                      </div>
                      <div class="form-hor-spacer"></div>
                      <input formControlName="phone" class="phone-number" type="number" name="phone"
                        placeholder="Phone (optional)">

                      <div class="input-div">
                        <textarea formControlName="message" rows="6" placeholder="Message" maxlength="5000" id="Message"
                          name="message" data-name="Message"></textarea>
                        <span class="c-error error-pos"
                          *ngIf="contactForm.controls.message?.errors?.required && contactForm.controls.message?.touched">Message
                          is required.</span>
                      </div>

                      <!-- <div class="bg-light-color"></div> -->
                      <re-captcha class="pt-4" formControlName="captcha" (resolved)="resolved($event)"
                        siteKey="6LdukaopAAAAAAjIZ2PtDyq3EBLlAX650_kWrm2b"></re-captcha>
                      <div>
                        <span class="c-error error-pos"
                          *ngIf="contactForm.controls.captcha?.errors?.required && contactForm.controls.captcha?.touched && !submitted">Captcha
                          is required.</span>
                      </div>

                      <div class="form-check mt-3">
                        <input type="submit" value="{{submitText}}" data-wait="Please wait..." class="button w-button">
                        <label class="form-check-label">
                          <input formControlName="subscription" type="checkbox" class="form-check-input"
                            value="">Subscribe to our email list
                        </label>
                      </div>

                    </div>
                  </form>

                  <div *ngIf="submitted" class="success-message w-form-done" tabindex="-1" role="region"
                    aria-label="Contact Form success">
                    <div class="text-block-15">Thank you! Your submission has been received!</div>
                  </div>

                  <div *ngIf="submittedError" class="w-form-fail" tabindex="-1" role="region"
                    aria-label="Contact Form failure">
                    <div>Oops! Something went wrong while submitting the form.</div>
                  </div>

                </div>


                <!--  Second From -->

                <div class="w-form" *ngIf="formTwo">
                  <div class="dropdown-box">
                    <select name="type" class="select-dropdown" (change)="changeColor($event)">
                      <option value="1"> General Comment & Questions</option>
                      <option selected="selected" value="2"> Feedback & Testimonals</option>
                    </select>
                  </div>

                  <div class="in-form-text">
                    <p>
                      The Guru Granth Sahib Project recognizes its responsibility to correct errors promptly. The team
                      also acknowledges that theirs is a The purpose of this form is to capture specific detailed
                      feedback on The Guru Granth Sahib Project's new website. Please provide feedback based on your
                      experience on the site, ease of use, look and ability to access from computer, phone, and other
                      devices.
                    </p>
                  </div>

                  <!-- <div class="input-div" style="visibility: hidden;height: 1px;">

                    <iframe id="my-response-iframe" name="my-response-iframe" src="https://docs.google.com/forms/d/e/1RZ2G_iRbTso8ysYL5mBe-yOodUKciDgZA1RCEwyFVfI/viewform?embedded=true" width="100%" height="2350" frameborder="0" marginheight="0" marginwidth="0"  style="">Loading…</iframe>

                  </div> -->

                  <form id="my-form" [formGroup]="feedbackForm">

                    <div class="form-hor">
                      <div class="input-div">
                        <input formControlName="firstName" type="text" name="first-name" placeholder="First Name">
                        <span class="c-error"
                          *ngIf="feedbackForm.controls.firstName?.errors?.['required'] && feedbackForm.controls.firstName?.touched">First
                          Name is required.</span>
                      </div>
                      <div class="form-hor-spacer"></div>
                      <div class="input-div">
                        <input formControlName="lastName" type="text" name="last-name" placeholder="Last Name">
                        <span class="c-error"
                          *ngIf="feedbackForm.controls.lastName?.errors?.['required'] && feedbackForm.controls.lastName?.touched">Last
                          Name is required.</span>
                      </div>
                    </div>

                    <div class="form-inp-aa">

                      <div class="input-div">
                        <input formControlName="emailID" id="email" type="email" placeholder="Email">
                        <span class="c-error" *ngIf="feedbackForm.controls.emailID?.errors?.['email']">Email must be a
                          valid email address.</span>
                        <span class="c-error"
                          *ngIf="feedbackForm.controls.emailID?.errors?.['required'] &&  feedbackForm.controls.emailID?.touched">Email
                          is required.</span>
                      </div>
                      <div class="form-hor-spacer"></div>
                      <input formControlName="phone" type="number" name="phone" placeholder="Phone (optional)">

                      <div class="survey-question" style="display: block;">
                        <p>How Satisfied are you with the new website design?</p>

                        <div>
                          <div class="form-check">
                            <input formControlName="newDesign" type="radio" class="form-check-input" id="radio1"
                              value="Excellent">
                            <label class="form-check-label" for="radio1">Excellent - Continue as is</label>
                          </div>
                          <div class="form-check">
                            <input formControlName="newDesign" type="radio" class="form-check-input" id="radio2"
                              value="Good">
                            <label class="form-check-label" for="radio2">Good - Note the Minor observations</label>
                          </div>

                          <div class="form-check">
                            <input formControlName="newDesign" type="radio" class="form-check-input" id="radio2"
                              value="Adequate">
                            <label class="form-check-label" for="radio3">Adequate - Resolve the issues cited</label>
                          </div>

                          <div class="form-check">
                            <input formControlName="newDesign" type="radio" class="form-check-input" id="radio2"
                              value="Poor">
                            <label class="form-check-label" for="radio4">Poor - Rework based on the detailed
                              critique</label>
                          </div>
                        </div>

                        <p style="margin-top:5rem;">How easy is it to navigate the website?</p>

                        <div class="rating-section">

                          <div class="not-v-p">
                            <label for="">Not Very</label>
                          </div>

                          <div class="rating-box">
                            <div class="form-check">
                              <div><label for="">1</label></div>
                              <div>
                                <input formControlName="navigateWebsite" type="radio" class="form-check-input"
                                  id="radio2" value="1">
                              </div>
                            </div>

                            <div class="form-check">
                              <div><label for="">2</label></div>
                              <div>
                                <input formControlName="navigateWebsite" type="radio" class="form-check-input"
                                  id="radio2" value="2">
                              </div>
                            </div>

                            <div class="form-check">
                              <div><label for="">3</label></div>
                              <input formControlName="navigateWebsite" type="radio" class="form-check-input" id="radio2"
                                value="3">
                            </div>

                            <div class="form-check">
                              <div><label for="">4</label></div>
                              <input formControlName="navigateWebsite" type="radio" class="form-check-input" id="radio2"
                                value="4">
                            </div>

                            <div class="form-check">
                              <div><label for="">5</label></div>
                              <input formControlName="navigateWebsite" type="radio" class="form-check-input" id="radio2"
                                value="5">
                            </div>
                          </div>

                          <div class="not-v-p">
                            <label for="">Very Much</label>
                          </div>
                        </div>

                      </div>


                      <div class="multiple-line-question" style="display: bock;">
                        <div>
                          <label for="">Are you able to use the text and previous page feature on computer and mobile
                            device?</label>
                        </div>
                        <div class="input-div">
                          <input formControlName="compareWebsite" type="text" name="answer-1" placeholder="Your answer">
                          <span class="c-error"
                            *ngIf="feedbackForm.controls.compareWebsite?.errors?.['required'] && feedbackForm.controls.compareWebsite?.touched">Answer
                            is required.</span>
                        </div>

                        <div>
                          <label for="">Are you satisfied with how it work on a mobile device - iPhone, Andriod, iPad,
                            etc.? </label>
                        </div>
                        <div class="input-div">
                          <input formControlName="nativeDevices" type="text" name="answer-1" placeholder="Your answer">
                          <span class="c-error"
                            *ngIf="feedbackForm.controls.nativeDevices?.errors?.['required'] && feedbackForm.controls.nativeDevices?.touched">Answer
                            is required.</span>
                        </div>

                        <div>
                          <label for="">What are your key takeaways from this website?</label>
                        </div>
                        <div class="input-div">
                          <input formControlName="keyPoints" type="text" name="answer-1" placeholder="Your answer">
                          <span class="c-error"
                            *ngIf="feedbackForm.controls.keyPoints?.errors?.['required'] && feedbackForm.controls.keyPoints?.touched">Answer
                            is required.</span>
                        </div>

                        <div>
                          <label for="">What are some featured you wish our website had?</label>
                        </div>
                        <div class="input-div">
                          <input formControlName="websiteFeature" type="text" name="answer-1" placeholder="Your answer">
                          <span class="c-error"
                            *ngIf="feedbackForm.controls.websiteFeature?.errors?.['required'] && feedbackForm.controls.websiteFeature?.touched">Answer
                            is required.</span>
                        </div>


                      </div>

                      <div class="input-div">
                        <textarea formControlName="message" rows="6" placeholder="Message" maxlength="5000" id="Message"
                          name="message" data-name="Message"></textarea>
                        <span class="c-error error-pos"
                          *ngIf="feedbackForm.controls.message?.errors?.required && feedbackForm.controls.message?.touched">Message
                          is required.</span>
                      </div>
                      <re-captcha class="pt-4" formControlName="captcha" (resolved)="resolved($event)"
                        siteKey="6LdukaopAAAAAAjIZ2PtDyq3EBLlAX650_kWrm2b"></re-captcha>
                      <div>
                        <span class="c-error error-pos"
                          *ngIf="feedbackForm.controls.captcha?.errors?.required && feedbackForm.controls.captcha?.touched">Captcha
                          is required.</span>
                      </div>
                      <div class="form-check" style="padding-top: 20px;">
                        <input [disabled]="submitText === 'Submitting..'" (click)="onSubmitFeedback()" type="submit"
                          value="{{submitText}}" data-wait="Please wait..." class="button w-button">
                        <label class="form-check-label">
                          <!-- <input formControlName="subscription" type="checkbox" class="form-check-input" value="">Subscribe to our email list -->
                        </label>
                      </div>

                    </div>
                  </form>

                  <div *ngIf="submitted" class="success-message w-form-done" tabindex="-1" role="region"
                    aria-label="Contact Form success">
                    <div class="text-block-15">Thank you! Your Feedback has been received!</div>
                  </div>

                  <div *ngIf="submittedError" class="w-form-fail" tabindex="-1" role="region"
                    aria-label="Contact Form failure">
                    <div>Oops! Something went wrong while submitting the form.</div>
                  </div>


                </div>

              </div>
            </div>
          </div>
        </div>
        
        <div class="static-content-paragraph">
          <div class="id smaller sub-form">
            <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
              <div class="static-content-heading-wrapper">{{activeLanguageTranslations?.correctionLabel}}</div>
              <div class="static-content-paragraph">
                {{activeLanguageTranslations?.paragraph2 | translate }}
              </div>
              <div class="static-content-paragraph">
                {{activeLanguageTranslations?.paragraph3 | translate }}
              </div>
              <div class="static-content-paragraph sggs-link">
                <a class="know-more"
                  href="mailto:{{activeLanguageTranslations?.correctionEmail}} ">{{activeLanguageTranslations?.correctionEmail}}
                </a>
              </div>

              <!-- <div class="begin-journy" [class.row]="isHandsetPortrait">
                <div class="left-section" [style.width]="!isHandsetPortrait ? '60%' : ''">
                  <div class="journey-image">
                    <img _ngcontent-utw-c105=""
                      src="https://assets.website-files.com/5db2238fbc53f8e367cb2499/5dcdb27870f8ecc979c39d27_Logo%20reference%202.jpg"
                      sizes="135px"
                      srcset="https://assets.website-files.com/5db2238fbc53f8e367cb2499/5dcdb27870f8ecc979c39d27_Logo%20reference%202-p-500.jpeg 500w, https://assets.website-files.com/5db2238fbc53f8e367cb2499/5dcdb27870f8ecc979c39d27_Logo%20reference%202-p-800.jpeg 800w, https://assets.website-files.com/5db2238fbc53f8e367cb2499/5dcdb27870f8ecc979c39d27_Logo%20reference%202.jpg 1024w"
                      alt="Decorative Image" class="image-9">
                  </div>
                  <div class="custom-content">
                    <h2>Begin the Journey</h2>
                    <p>Connect with Sabad and allow it to strengthen your mind and heart. Enter your email to receive
                      updates and be notified when new Banis are available on the Guru Granth Sahib Project.</p>
                  </div>


                </div>
                <div class="right-section" [style.width]="!isHandsetPortrait ? '40%' : ''"
                  [class.mt-4]="isHandsetPortrait">
                  <form [formGroup]="subscribeForm" (ngSubmit)="onSubscribe()">
                    <div class="form-hor">
                      <div class="input-div">
                        <input formControlName="firstName" type="text" name="first-name" placeholder="Your Name">
                        <span class="c-error"
                          *ngIf="subscribeForm.controls.firstName?.errors?.['required'] &&  subscribeForm.controls.firstName?.touched">Your
                          Name is required.</span>
                      </div>
                    </div>
                    <div class="form-hor">
                      <div class="input-div">
                        <input formControlName="emailID" id="email" type="email" placeholder="Email">
                        <span class="c-error" *ngIf="subscribeForm.controls.emailID?.errors?.['email']">Email must be a
                          valid email address.</span>
                        <span class="c-error"
                          *ngIf="subscribeForm.controls.emailID?.errors?.['required'] &&  subscribeForm.controls.emailID?.touched">Email
                          is required.</span>
                      </div>
                    </div>
                    <div class="subscribe-b">
                      <input type="submit" value="{{subscribeText}}" data-wait="Please wait..." class="button w-button">
                    </div>
                  </form>
                  <div *ngIf="subscribed" class="success-message subscribe-msg w-form-done" tabindex="-1" role="region"
                    aria-label="Contact Form success">
                    <div class="text-block-15">Thank you! Your subscription has been done!</div>
                  </div>
                </div>
              </div> -->
              <div class="my-5">
                <app-newsletter></app-newsletter>
              </div>
            </div>
          </div>
        </div>

        <!-- Second Form   -->
        <div class="static-content-paragraph">
          <div class="id smaller sub-form">
            <!--  <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
                <div class="static-content-heading-wrapper">{{activeLanguageTranslations?.correctionLabel}}</div>
                <div class="static-content-paragraph">
                  {{activeLanguageTranslations?.paragraph2 | translate }}
                </div>
                <div class="static-content-paragraph">
                  {{activeLanguageTranslations?.paragraph3 | translate }}
                </div>
                <div class="static-content-paragraph sggs-link">
                  <a class="know-more" href="mailto:{{activeLanguageTranslations?.correctionEmail}} ">{{activeLanguageTranslations?.correctionEmail}} </a>
                </div>

                <div class="begin-journy" [class.row]="isHandsetPortrait">
                  <div class="left-section" [style.width]="!isHandsetPortrait ? '60%' : ''">
                    <div class="journey-image">
                      <img _ngcontent-utw-c105="" src="https://assets.website-files.com/5db2238fbc53f8e367cb2499/5dcdb27870f8ecc979c39d27_Logo%20reference%202.jpg" sizes="135px" srcset="https://assets.website-files.com/5db2238fbc53f8e367cb2499/5dcdb27870f8ecc979c39d27_Logo%20reference%202-p-500.jpeg 500w, https://assets.website-files.com/5db2238fbc53f8e367cb2499/5dcdb27870f8ecc979c39d27_Logo%20reference%202-p-800.jpeg 800w, https://assets.website-files.com/5db2238fbc53f8e367cb2499/5dcdb27870f8ecc979c39d27_Logo%20reference%202.jpg 1024w" alt="Decorative image" class="image-9">
                    </div>
                    <div class="custom-content">
                      <h2>Begin the Journey</h2>
                      <p>Connect with Sabad and allow it to strengthen your mind and heart. Enter your email to receive updates and be notified when new Banis are available on the Guru Granth Sahib Project.</p>
                    </div>
                    
                                      
                  </div>
                  <div class="right-section" [style.width]="!isHandsetPortrait ? '40%' : ''" [class.mt-4]="isHandsetPortrait">
                    <form [formGroup]="subscribeForm" (ngSubmit)="onSubscribe()">
                    <div class="form-hor">
                      <div class="input-div">
                        <input formControlName="firstName" type = "text" name = "first-name" placeholder = "Your Name" >
                        <span class="c-error" *ngIf="subscribeForm.controls.firstName?.errors?.['required'] &&  subscribeForm.controls.firstName?.touched"  >Your Name is required.</span>
                      </div>
                    </div>
                    <div class="form-hor"> 
                      <div class="input-div">
                        <input formControlName="emailID" id="email" type="email" placeholder = "Email" >
                        <span class="c-error" *ngIf="subscribeForm.controls.emailID?.errors?.['email']" >Email must be a valid email address.</span>
                        <span class="c-error" *ngIf="subscribeForm.controls.emailID?.errors?.['required'] &&  subscribeForm.controls.emailID?.touched" >Email is required.</span>
                      </div>
                    </div>
                    <div class="subscribe-b">
                      <input type="submit" value="{{subscribeText}}" data-wait="Please wait..." class="button w-button">
                    </div>
                    </form>
                    <div *ngIf="subscribed" class="success-message subscribe-msg w-form-done" tabindex="-1" role="region" aria-label="Contact Form success">
                      <div class="text-block-15">Thank you! Your subscription has been done!</div>
                    </div>
                  </div>
                </div>
              </div> -->

            <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
              <div class="static-content-heading-wrapper">Donate</div>

              <div class="donate-section">
                <div class="donate-left-side">
                  <h2 class="pl-20">Support The Guru Granth Sahib Project</h2>
                  <p class="pl-20">In today's divisive world, the message flowing from the Guru Granth Sahib is needed
                    more than ever. This project aspires to make the Guru Granth Sahib accessible to English speakers
                    globally. This work is made possible by donations from passionate people just like you.</p>
                  <div *ngIf="isHandsetPortrait" class="donate-right-side">
                    <img alt="Decorative Image" src="/assets/images/donate-img.webp" width="270px">
                  </div>
                  <div class="donate-btn" [class.mt-4]="isHandsetPortrait">
                    <a class="button w-button" href="https://sikhri.org/donate" target="_blank">{{ "Donate" | translate
                      }}</a>
                    <!-- <input type="submit" value="Donate" data-wait="Please wait..." class="button w-button"> -->
                  </div>
                </div>
                <div *ngIf="!isHandsetPortrait" class="donate-right-side">
                  <img alt="Decorative Image" src="/assets/images/donate-img.webp" width="270px">
                </div>

              </div>


            </div>


          </div>
        </div>



      </div>
      <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>